<template lang="pug">
#modal-upload-recebimentos-lote
    el-dialog.modal-upload-recebimentos-lote(
        :visible.sync='show',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        width='56%',
        @close='fecharModal'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.titulo') }}

        .modal-upload-recebimentos-lote__body
            el-alert(
                :title='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.descricao")',
                type='info',
                show-icon,
                :closable='false'
            )

            .modal-upload-recebimentos-lote__upload
                el-upload(
                    action='#',
                    drag,
                    :auto-upload='false',
                    :show-file-list='false',
                    :on-change='selecionarArquivo',
                    :on-exceed='onExceed',
                    :limit='1',
                    ref='uploadRecebimentos'
                )
                    i.el-icon-upload
                    .el-upload__text
                        | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.arrasteArquivo') }}
                        em {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.cliqueUpload') }}
                    .el-upload__tip(slot='tip') {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.arquivosPermitidos') }}

            .modal-upload-recebimentos-lote__arquivo(v-if='arquivoSelecionado')
                i.el-icon-document
                .modal-upload-recebimentos-lote__arquivo-info
                    span.modal-upload-recebimentos-lote__arquivo-label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.arquivoSelecionado') }}
                    span.modal-upload-recebimentos-lote__arquivo-nome {{ arquivoSelecionado.name }}
                span.modal-upload-recebimentos-lote__arquivo-tamanho {{ tamanhoArquivoSelecionado }}
                el-button(
                    type='text',
                    icon='el-icon-close',
                    @click='limparArquivo'
                )

            .modal-upload-recebimentos-lote__status(v-if='dadosLote')
                .modal-upload-recebimentos-lote__status-item
                    span.label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.planilhaImportada') }}
                    el-tooltip(
                        v-if='dadosLote.planilha || dadosLote.nomeArquivo',
                        effect='dark',
                        :content='dadosLote.planilha || dadosLote.nomeArquivo',
                        placement='top'
                    )
                        span.value {{ dadosLote.planilha || dadosLote.nomeArquivo }}
                    span.value(v-else) -

                .modal-upload-recebimentos-lote__status-item
                    span.label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.status') }}
                    el-tag(:type='statusTagType', size='small')
                        i.el-icon-loading(v-if='emProcessamento')
                        | {{ statusTexto }}

                .modal-upload-recebimentos-lote__status-item
                    span.label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.ultimaAtualizacao') }}
                    span.value {{ dadosLote.ultimaAtualizacao || dadosLote.dataAtualizacao || dadosLote.dataCadastro || '-' }}

            .modal-upload-recebimentos-lote__modelo
                .modal-upload-recebimentos-lote__modelo-info
                    i.el-icon-document
                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.modeloDescricao') }}
                el-button(
                    type='text',
                    icon='el-icon-download',
                    @click='downloadPlanilhaExemplo'
                ) {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.baixarModeloPlanilha') }}

        footer.modal-upload-recebimentos-lote__footer(slot='footer')
            el-button(@click='fecharModal', :disabled='carregando') {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.fechar') }}
            el-button(
                type='primary',
                :loading='carregando',
                :icon='carregando ? "el-icon-loading" : "el-icon-upload2"',
                @click='enviarArquivo',
                :disabled='!arquivoSelecionado'
            ) {{ carregando ? '' : $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.enviarPlanilha') }}
</template>

<script>
export default {
    name: 'ModalUploadRecebimentosLote',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        carregando: {
            type: Boolean,
            default: false
        },
        dadosLote: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            arquivoSelecionado: null
        };
    },

    computed: {
        statusCodigo() {
            return this.dadosLote && this.dadosLote.statusCodigo
                ? this.dadosLote.statusCodigo
                : '';
        },
        emProcessamento() {
            return ['EM_PROCESSAMENTO', 'PROCESSANDO'].includes(
                this.statusCodigo
            );
        },
        statusTagType() {
            if (['CONCLUIDO', 'PROCESSADO'].includes(this.statusCodigo)) {
                return 'success';
            }

            if (
                ['ERRO_PROCESSAR', 'ERRO_AO_PROCESSAR'].includes(
                    this.statusCodigo
                )
            ) {
                return 'danger';
            }

            if (this.emProcessamento) {
                return 'info';
            }

            return 'warning';
        },
        statusTexto() {
            if (this.dadosLote && this.dadosLote.status) {
                return this.dadosLote.status;
            }

            if (['CONCLUIDO', 'PROCESSADO'].includes(this.statusCodigo)) {
                return this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.statusConcluido'
                );
            }

            if (
                ['ERRO_PROCESSAR', 'ERRO_AO_PROCESSAR'].includes(
                    this.statusCodigo
                )
            ) {
                return this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.statusErroProcessar'
                );
            }

            if (this.emProcessamento) {
                return this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.statusProcessamento'
                );
            }

            return this.$t(
                'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.statusAguardando'
            );
        },
        tamanhoArquivoSelecionado() {
            if (!this.arquivoSelecionado) {
                return '';
            }

            const tamanhoMb = this.arquivoSelecionado.size / 1024 / 1024;
            return `${tamanhoMb.toFixed(2)} MB`;
        }
    },

    watch: {
        show(value) {
            if (!value) {
                this.limparArquivo();
            }
        }
    },

    methods: {
        onExceed() {
            this.$notify.warning({
                message: this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.limiteArquivo'
                )
            });
        },
        selecionarArquivo(arquivo) {
            this.arquivoSelecionado = arquivo;
        },
        enviarArquivo() {
            if (!this.arquivoSelecionado || this.carregando) {
                return;
            }

            this.$emit('enviar', this.arquivoSelecionado);
            this.limparArquivo();
        },
        downloadPlanilhaExemplo() {
            const link = document.createElement('a');
            link.setAttribute(
                'download',
                this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.modeloPlanilhaNome'
                )
            );
            link.href = this.$t(
                'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.modeloPlanilhaUrl'
            );
            document.body.appendChild(link);
            link.click();
            link.remove();
        },
        limparArquivo() {
            this.arquivoSelecionado = null;
            if (this.$refs.uploadRecebimentos) {
                this.$refs.uploadRecebimentos.clearFiles();
            }
        },
        fecharModal() {
            if (this.carregando) {
                return;
            }

            this.$emit('close');
        }
    }
};
</script>

<style lang="scss">
#modal-upload-recebimentos-lote {
    .modal-upload-recebimentos-lote {
        .el-dialog__header {
            padding: 16px 20px;
            background: var(--primary) !important;
            color: var(--white);
        }

        .el-dialog__headerbtn .el-dialog__close {
            color: var(--white);
        }

        &__body {
            display: flex;
            flex-direction: column;
            gap: 18px;
        }

        &__upload {
            .el-upload,
            .el-upload-dragger {
                width: 100%;
            }
        }

        &__arquivo {
            display: grid;
            grid-template-columns: auto 1fr auto auto;
            gap: 10px;
            align-items: center;
            padding: 10px 12px;
            border: 1px solid #dcdfe6;
            border-radius: 6px;
            background: #fbfbfb;

            > i {
                color: var(--primary);
                font-size: 20px;
            }

            .el-button {
                padding: 0;
            }
        }

        &__arquivo-info {
            display: flex;
            flex-direction: column;
            min-width: 0;
        }

        &__arquivo-label,
        &__arquivo-tamanho {
            color: #6b7280;
            font-size: 12px;
        }

        &__arquivo-nome {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: 600;
        }

        &__status {
            display: grid;
            grid-template-columns: 2fr 1fr 1.4fr;
            gap: 12px;
            padding: 14px;
            border: 1px solid #e5e5e5;
            border-radius: 6px;
            background: #fbfbfb;
        }

        &__status-item {
            display: flex;
            flex-direction: column;
            gap: 4px;
            min-width: 0;

            .label {
                color: #6b7280;
                font-size: 12px;
                font-weight: 600;
            }

            .value {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        &__modelo {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            padding: 10px 12px;
            border: 1px solid #e5e7eb;
            border-radius: 6px;
            background: #fbfbfb;

            .el-button {
                flex: 0 0 auto;
            }
        }

        &__modelo-info {
            display: flex;
            align-items: center;
            gap: 8px;
            min-width: 0;
            color: #6b7280;
            font-size: 13px;

            i {
                color: var(--primary);
                font-size: 18px;
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            gap: 8px;
        }
    }
}
</style>
